import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import AbstractComponent from './abstract-component';

Swiper.use([Pagination]);

export default class GoogleReviews extends AbstractComponent {
    constructor(el) {
        super(el);
        this.sliderObject = null;
        this.initSlider();
    }

    initSlider() {
        const slider = this.$el.querySelector('.c-google-reviews__swiper');
        if (!slider) {
            return;
        }

        const pagination = this.$el.querySelector('.c-google-reviews__pagination');

        this.sliderObject = new Swiper(slider, {
            slidesPerView: 1.15,
            spaceBetween: 16,
            grabCursor: true,
            pagination: pagination
                ? {
                    el: pagination,
                    clickable: true,
                }
                : undefined,
            breakpoints: {
                879.98: {
                    enabled: false,
                },
            },
        });
    }

    destroy() {
        if (this.sliderObject) {
            this.sliderObject.destroy(true, true);
            this.sliderObject = null;
        }
    }
}
